'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routeReducer = exports.locationHelpers = exports.routeActions = undefined;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularRoute = require('angular-route');

var _angularRoute2 = _interopRequireDefault(_angularRoute);

var _routeMiddleware = require('./route-middleware');

var _routeMiddleware2 = _interopRequireDefault(_routeMiddleware);

var _routeListener = require('./route-listener');

var _routeListener2 = _interopRequireDefault(_routeListener);

var _actionCreaters = require('./action-creaters');

var _locationHelpers = require('./location-helpers');

var _routeReducer2 = require('./route-reducer');

var _routeReducer3 = _interopRequireDefault(_routeReducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('ng-redux-route', [_angularRoute2.default]).factory('ngRouteMiddleware', _routeMiddleware2.default).run(_routeListener2.default).name;
var routeActions = exports.routeActions = { setLocation: _actionCreaters.setLocation, back: _actionCreaters.back };
var locationHelpers = exports.locationHelpers = { setUrl: _locationHelpers.setUrl, setPath: _locationHelpers.setPath, setSearch: _locationHelpers.setSearch, setHash: _locationHelpers.setHash, setState: _locationHelpers.setState };
var routeReducer = exports.routeReducer = _routeReducer3.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/ng-redux-route/lib/index.js
// module id = 96
// module chunks = 0